var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row scta-box" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _c("center", [_c("h1", [_vm._v("特定商取引法に基づく表記")])]),
          _c("div", { staticClass: "date" }, [_vm._v("2025年9月17日 第一版")]),
          _vm._m(0),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("h2", [_vm._v("事業者名")]),
      _c("p", [_vm._v("株式会社indent")]),
      _c("h2", [_vm._v("代表者")]),
      _c("p", [_vm._v("釜形　勇気")]),
      _c("h2", [_vm._v("所在地")]),
      _c("p", [
        _vm._v(
          "〒101-0061　東京都千代田区神田三崎町3丁目6番12号神田三崎町ビル4階"
        ),
      ]),
      _c("h2", [_vm._v("お問い合わせ先")]),
      _c("p", [_vm._v("nola.cs@indent.co.jp")]),
      _c("p", [
        _vm._v(
          "※ 表示を省略している事項は、取引時に請求があれば遅滞なくご連絡します。"
        ),
      ]),
      _c("h2", [_vm._v("販売価格")]),
      _c("p", [
        _vm._v(
          " 商品ごとに異なります。各サービスの申込手続中に表示される価格（表示価格は消費税込みの価格です）をご確認ください。 "
        ),
      ]),
      _c("h2", [_vm._v("商品代金以外に必要な料金")]),
      _c("p", [
        _vm._v(
          " 当サイトのページの閲覧、コンテンツ購入、ソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金は、お客様のご負担となります。 "
        ),
      ]),
      _c("h2", [_vm._v("お支払い方法")]),
      _c("p", [_vm._v("Webサイトをご利用の場合")]),
      _c("ul", [
        _c("li", { staticStyle: { "list-style-type": "disc" } }, [
          _vm._v("クレジットカード決済"),
        ]),
      ]),
      _c("p", [_vm._v("スマホアプリをご利用の場合")]),
      _c("ul", [
        _c("li", { staticStyle: { "list-style-type": "disc" } }, [
          _vm._v(
            " Apple Inc. や Google LLC 等、購入に係る決済を代行する会社が提供するお支払い方法 "
          ),
        ]),
      ]),
      _c("h2", [_vm._v("代金の支払時期")]),
      _c("ol", { attrs: { start: "1" } }, [
        _c("li", [
          _c("strong", [_vm._v("Nolaプレミアム（サブスクリプション）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                " 申込時、および各更新日に課金されます。お客様が利用されている決済サービスの規約に従います。 "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _c("strong", [_vm._v("Fish（サービス内通貨）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v("購入手続き完了時に課金されます。"),
            ]),
          ]),
        ]),
      ]),
      _c("h2", [_vm._v("役務の提供時期")]),
      _c("ol", { attrs: { start: "1" } }, [
        _c("li", [
          _c("strong", [_vm._v("Nolaプレミアム（サブスクリプション）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                "お支払い手続き完了後、直ちにプレミアム機能をご利用いただけます。"
              ),
            ]),
          ]),
        ]),
      ]),
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _c("strong", [_vm._v("Fish（サービス内通貨）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                "お支払い手続き完了後、直ちにお客様のアカウントに付与されます。"
              ),
            ]),
          ]),
        ]),
      ]),
      _c("h2", [_vm._v("キャンセル・中途解約について")]),
      _c("ol", { attrs: { start: "1" } }, [
        _c("li", [
          _c("strong", [_vm._v("Nolaプレミアム（サブスクリプション）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                " いつでもサブスクリプションの解約手続きが可能です。解約手続きをされた場合、次回の更新は行われず、契約期間の満了をもってサービスの提供が終了します。 "
              ),
            ]),
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                " 契約期間の途中で解約された場合でも、日割り計算による返金を含め、一切の返金はいたしかねますので、あらかじめご了承ください。 "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _c("strong", [_vm._v("Fish（サービス内通貨）")]),
          _c("ul", [
            _c("li", { staticStyle: { "list-style-type": "disc" } }, [
              _vm._v(
                " ご購入手続き完了後は申し込みを撤回・解除することはできません。"
              ),
              _c("br"),
              _vm._v("あらかじめご了承ください。 "),
            ]),
            _c(
              "li",
              {
                staticStyle: {
                  "list-style-type": "none",
                  "text-indent": "-1em",
                },
              },
              [
                _vm._v(
                  " ※ Fishを利用した機能が利用できなかったなどの不具合があった場合は、不具合発生から7日以内を目処に、本サイト・本アプリのお問い合わせよりご連絡ください。 "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("h2", [_vm._v("ソフトウェアの動作環境")]),
      _c("p", [
        _vm._v(" Nolaをご利用いただくために必要な動作環境は「"),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://booming-buckthorn-e8b.notion.site/6ae1258a5e854528b7c0e7e8f2fdba30?source=copy_link",
            },
          },
          [_vm._v("Nolaヘルプページ")]
        ),
        _vm._v("」をご確認ください。 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }